/*
  ms-bundle-smart.js — Mile Sports: personaliseret rækkefølge i PDP-bundle-widgeten
  ("Køb sammen med"). Additivt lag, rører IKKE theme.js.

  Vælger de 2 mest relevante varer fra den eksisterende (kuraterede) bundle-liste og
  flytter dem øverst; resten skjules bag "Se flere produkter". Prioritet:
    1) Senest sete produkter (localStorage "…:recently-viewed", skrevet af js-variables.liquid)
       som findes i listen — nyeste først.
    2) Komplementære varer der passer til det aktuelle produkt (kategori via titel-nøgleord,
       samme køn foretrukket) — fx t-shirt → shorts/tights, vindjakke → track pants/long-sleeve.
    3) Default: listens egen rækkefølge.
  De 2 valgte sorteres billigst øverst (så 3-for-2-gratis-varen står øverst).

  Sikkert fordi theme.js læser valg live via querySelectorAll('input[name="bundles"]:checked')
  og bruger event-delegation — ren omrokering/skjul påvirker ikke add-to-cart eller bundle:change.
*/
(function () {
  var CAT_MAP = {
    't-shirt': ['shorts', 'tights', 'singlet'],
    'long-sleeve': ['tights', 'vindjakke', 'track'],
    'singlet': ['shorts', 'tights'],
    'race-top': ['shorts', 'tights'],
    'shorts': ['t-shirt', 'singlet', 'tights'],
    'tights': ['t-shirt', 'long-sleeve', 'vindjakke'],
    'vindjakke': ['track', 'long-sleeve', 't-shirt'],
    'track': ['t-shirt', 'vindjakke', 'long-sleeve']
  };
  var DEFAULT_COMP = ['shorts', 't-shirt', 'tights'];

  // Kategori via titel/handle-nøgleord. Rækkefølgen er vigtig:
  // "long sleeve" før "t-shirt" (long sleeve-titler indeholder "t-shirt").
  function classify(text) {
    var t = (text || '').toLowerCase();
    if (/long[\s-]?sleeve/.test(t)) return 'long-sleeve';
    if (/race[\s-]?top/.test(t)) return 'race-top';
    if (/t-?shirt/.test(t)) return 't-shirt';
    if (/singlet/.test(t)) return 'singlet';
    if (/shorts/.test(t)) return 'shorts';
    if (/tights/.test(t)) return 'tights';
    if (/vindjakke|jakke/.test(t)) return 'vindjakke';
    if (/track|l[øo]bebuks/.test(t)) return 'track';
    return null;
  }

  function gender(text) {
    var t = (text || '').toLowerCase();
    if (/dame/.test(t)) return 'dame';
    if (/herre/.test(t)) return 'herre';
    if (/barn|b[øo]rn|kids|junior/.test(t)) return 'born';
    return null;
  }

  function readRecentlyViewed() {
    try {
      var key = Object.keys(localStorage).filter(function (k) {
        return /:recently-viewed$/.test(k);
      })[0];
      if (!key) return [];
      var arr = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function readConfig(details) {
    var section = details.closest('.shopify-section') || document;
    var el = section.querySelector('[data-ms-bundle-smart]') ||
             document.querySelector('[data-ms-bundle-smart]');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  function initDetails(details, cfg) {
    var content = details.querySelector('.details__content');
    if (!content) return;

    var rows = Array.prototype.slice.call(
      content.querySelectorAll('label.product-bundle__info')
    );
    if (rows.length <= 2) return; // intet at rangere

    var curPid = cfg && cfg.pid ? String(cfg.pid)
      : (window.meta && window.meta.product ? String(window.meta.product.id) : '');
    var curText = ((cfg && cfg.handle) || '') + ' ' + ((cfg && cfg.title) || '');
    var curCat = classify(curText);
    var curGender = gender((cfg && cfg.title) || '');

    var items = rows.map(function (el) {
      var input = el.querySelector('input[name="bundles"]');
      var titleEl = el.querySelector('.horizontal-product__title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      return {
        el: el,
        pid: el.getAttribute('data-ms-pid') || '',
        price: input ? parseInt(input.getAttribute('data-price'), 10) : NaN,
        title: title,
        cat: classify(title),
        gender: gender(title),
        available: input ? !input.disabled : true
      };
    });

    var chosen = [];
    function pick(it) {
      if (it && chosen.indexOf(it) === -1 && chosen.length < 2) chosen.push(it);
    }

    // 1) Senest sete (nyeste først), ekskl. aktuelt produkt, kun varer der er i listen
    var rv = readRecentlyViewed();
    for (var i = 0; i < rv.length && chosen.length < 2; i++) {
      var id = String(rv[i]);
      if (curPid && id === curPid) continue;
      var match = items.filter(function (it) {
        return it.pid === id && it.available;
      })[0];
      if (match) pick(match);
    }

    // 2) Komplementær-fyld efter kategori (samme køn foretrukket, billigst)
    if (chosen.length < 2) {
      var comps = (curCat && CAT_MAP[curCat]) || DEFAULT_COMP;
      for (var c = 0; c < comps.length && chosen.length < 2; c++) {
        var cat = comps[c];
        var pool = items.filter(function (it) {
          return it.cat === cat && it.available && chosen.indexOf(it) === -1;
        });
        var same = pool.filter(function (it) {
          return curGender && it.gender === curGender;
        });
        var list = (same.length ? same : pool).slice().sort(function (a, b) {
          return (a.price || 0) - (b.price || 0);
        });
        if (list[0]) pick(list[0]);
      }
    }

    // 3) Default-fyld (ledige først, derefter hvad som helst)
    for (var d = 0; d < items.length && chosen.length < 2; d++) {
      if (items[d].available) pick(items[d]);
    }
    for (var e = 0; e < items.length && chosen.length < 2; e++) pick(items[e]);

    if (chosen.length < 2) return;

    // Billigst øverst (gratis-varen står øverst når begge er valgt)
    chosen.sort(function (a, b) { return (a.price || 0) - (b.price || 0); });

    // Omrokér DOM: valgte + resten i original rækkefølge, indsat før "Se flere"-knappen.
    // Toggle-input + <style> ligger før labels og forbliver urørt; knappen forbliver sidst.
    var moreBtn = content.querySelector('.ms-bundle-more-btn');
    var rest = items.filter(function (it) { return chosen.indexOf(it) === -1; });
    var ordered = chosen.concat(rest);
    ordered.forEach(function (it) { content.insertBefore(it.el, moreBtn); });

    // Synlighed: de 2 valgte vises, resten skjules bag toggle
    items.forEach(function (it) {
      if (chosen.indexOf(it) !== -1) it.el.classList.remove('ms-bundle-extra');
      else it.el.classList.add('ms-bundle-extra');
    });
  }

  function init() {
    document.querySelectorAll('details[is="product-bundle-details"]').forEach(function (details) {
      if (details.__msSmart) return;
      details.__msSmart = true;
      try { initDetails(details, readConfig(details)); } catch (e) { /* fail-silent */ }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
